(function($){
    var _INDEX_MSG_VIEW_MODEL = {
        page: 1,							//最后下载的页
		page_size:20,
		total_page:1,
		_SCROLL_BOTTOM_LOADING:false,		//无限滚动刷新
        newsList: ko.observableArray([]),
		total_msg_list:[],					//所有数据
		commonGoodsConfig: ko.observableArray(),
		openJsIm: ko.observable(false), //开启寄售im
		showDetail: function (goods_type, refer_type, subject_id, biz_game_id){
			var isCommonGoods = this.isCommonGoods(goods_type);
			switch(refer_type)
            {
                case 0: //未知
                    break;
                case 1: //跳到详情下的留言
                    if (biz_game_id == 0){
						return false;
					}
					if (goods_type == 10 || goods_type == 12 ||goods_type == 2) {
						return true;
                    } else if (goods_type == 9 || goods_type == 19){
					} else if (goods_type == 1) {
						return true;
					} else if (goods_type == 5) {
						return true;
                    }
                    break;
                case 2: //订单详情
                    if (goods_type == 10 || goods_type == 12 || goods_type == 2 || goods_type == 1 || goods_type == 5 || goods_type == 31 || goods_type == 35){  
                    	return true; 
                    } else if (goods_type == 1){
                    } else if (goods_type == 5){
                    } else if (goods_type == 9){
                        return true;                               
					} else if (isCommonGoods){
						return true;
					}
                    break;
                case 3: //商品详情

                    if(subject_id == 6570){
	                     return true;
	                  }
					if (goods_type == 10 || goods_type == 12 || goods_type == 2 || goods_type == 1 || goods_type == 5 || goods_type == 31 || goods_type == 35){   
                		return true;
                    } else if (goods_type == 9){   
                		return true;
                    } else {
                    	return false;
                    }
                    break;
                case 4: //跳到钱包首页  refer_id填0
                    break;
                case 5: //跳到支付宝绑定页 refer_id填0
                    break;
                case 6: //
                    break;
				case 7: //到订单评价页面 
					break;
                case 8: //到个人中心  
                    break;
				case 9: //到个人信用页，即个人中心页
					return true;
                    break;
                case 10: //到点券商品
                    break;
                case 11: //转到G聊
                    break;
				case 12: //转到寄售im
					if (this.openJsIm() == true){
						return true;
					} else {
						return false;
					}
				case 13: //收货充值 
					return true;
					break;
				case 14: //收货管理
					return false;
					break;
				case 19: //获取临时密码
					return true;
					break;
				case 20: //投诉建议-客服回复
					return true;
					break;
                default:
                    break;
            }
		},
		goto: function (data) {
			var refer_type = data.refer_type;
			var goods_type = data.goods_type;
		      var refer_id = data.refer_id;
		      var game_id = data.biz_game_id;
			var subject_id = data.subject_id;
			var isCommonGoods = this.isCommonGoods(goods_type);
            if (refer_type == 1) {
                if (goods_type == 2 || goods_type == 1 || goods_type == 5 || goods_type == 10 || goods_type == 12){
					$.router.load('/h5/goods/comment/index.html?book_id=' + refer_id + '&goods_type=' + goods_type);
				} else {
					$.toast('暂不支持，请去电脑上操作。');
				}

			}else if (refer_type == 2) {
				//$.router.load('/h5/order/detail/index.html?orderId=' + refer_id + '&goods_type=' + goods_type + '&from=' + encodeURIComponent(location.href));
				if (goods_type == 2 || goods_type == 1 || goods_type == 5 || goods_type == 10 || goods_type == 12 || isCommonGoods){
					$.router.load('/h5/order/detail/index.html?orderId=' + refer_id + '&goods_type=' + goods_type + '&game_id=' + game_id + '&from=' + encodeURIComponent(location.href));
				} else if(goods_type == 31 || goods_type == 35) {
					$.router.load('/h5/order/detail_db/index.html?orderId=' + refer_id + '&goods_type=' + goods_type + '&game_id=' + game_id + '&from=' + encodeURIComponent(location.href));
				} else {
					$.toast('暂不支持，请去电脑上操作。');
				}
			} else if (refer_type == 3) {
				if (goods_type == 2 || goods_type == 10 || goods_type == 12 || goods_type == 1 || goods_type == 5 || isCommonGoods){ 
                   $.router.load('/h5/goods/detail/index.html?book_id=' + refer_id + '&goods_type=' + goods_type + '&game_id=' + game_id);
				} else if (goods_type == 31 || goods_type == 35) {
					$.router.load('/h5/goods/detail_db/index.html?book_id=' + refer_id + '&goods_type=' + goods_type + '&game_id=' + game_id);
				} else if (goods_type == 9) {
					$.toast('暂不支持，请在电脑上操作。');
				}
			} else if (refer_type == 9) {
				$.router.load('/h5/my/credit/index.html');
			} else if (refer_type == 12){//转到寄售im
				var book_id = refer_id.split('_')[0];
				var group_id = refer_id.split('_')[1];//卖家一个book_id对应多个人聊天,需要知道group_id
				var from = 'system_msg';
				$.router.load('/h5/order/jsim/index.html?book_id=' + book_id + '&goods_type=' + goods_type + '&group_id=' + group_id + '&from=' + from);
			}else if(refer_type == 13){//跳钱包首页
				$.router.load('//qb.gmmsj.com/qbm/index/index.html?refer=h5');
			}else if(refer_type == 19){//跳小程序获取临时密码
				if($.os() == "gmmios" && window.bridge){
					if(window.bridge.callHandler){
						window.bridge.callHandler('openBrowserUrl',"https://a.gmmsj.com/wxqr_temppass4msg");
					}
				}else{
					$.router.load("https://a.gmmsj.com/wxqr_temppass4msg");
				}
			}else if(refer_type == 20){//投诉建议-客服回复
				$.router.load("https://www.gmmsj.com/h5/my/feedback_detail/index.html?identifier=" + refer_id);
			}else if(refer_type == 21){//标价校准
				$.router.load("https://www.gmmsj.com/h5/my/targetPrice/index.html?refer_id=" + refer_id);
			}
		},
		getNews: function(pageNo,scroll_bottom_refresh){
            var self = this;
			var cached_period=600;
			var user_msg_url="/gmminf/accountapi/config";
			var params={
				src_code:11,
				method:"QueryMessage",
				params:JSON.stringify({
					is_read: 2,
					count:self.page_size,
					page:pageNo
				})
			};
			$.ajaxBridgeCache(user_msg_url,function(response){
				if( $.BizReturnCodeCheck(response) && typeof(response.data)!="undefined" && typeof(response.data.data)!="undefined"){
					console.log("[PageReadyEntry-Msg][Process Msg List Response]");
					if (response.data.sum == 0){
						$('.infinite-scroll-preloader').hide();
						$('.no-list').show();
					} else{
					    self.page=pageNo;
						self.total_page= parseInt((response.data.sum-1)/self.page_size+1);
						var msgList=[];
						var readedMsgIds=[];
						for(var i in response.data.data){
							var msgItem=response.data.data[i];
							var item={
								msg_id: msgItem.msg_id || '',
								refer_id: msgItem.refer_id || '',
								msg_type: msgItem.msg_type || '',
								msg_title: msgItem.msg_title || '',
								content: msgItem.content || '',
								character_name: msgItem.character_name || '',
								subject_id: msgItem.subject_id || '',
								read_flag: msgItem.read_flag || '',
								create_time: msgItem.create_time || '',
								refer_type: msgItem.refer_type || '',
								msg_icon: msgItem.msg_icon || '',
								goods_type: msgItem.goods_type || '',
								biz_game_id: msgItem.biz_game_id || ''
							};
							var regex = /https?:\/\/[^\s]+/; //匹配url的正则
							if (msgItem.refer_type == 15){
								item.content = msgItem.content.replace(regex, '<a href="$&" target="_blank" class="external">$&</a>');
							}
							msgList.push(item);
							if(0==msgItem.read_flag){
								readedMsgIds.push(msgItem.msg_id);
							}
						}
						if(pageNo==1){
							self.total_msg_list=[];
						}
						self.total_msg_list=self.total_msg_list.concat(msgList);
						self.newsList(self.total_msg_list);
						self.updateMessageReadFlag(readedMsgIds);
					}
				}
				if(scroll_bottom_refresh){
					$('.infinite-scroll-preloader').hide();
					$.refreshScroller();
					setTimeout(function (){
						self._SCROLL_BOTTOM_LOADING=false;
					},500);
				}
			},
			params,"GET",false,cached_period,function (response){
				return  ($.BizReturnCodeCheck(response) &&  typeof(response.data)!="undefined" && typeof(response.data.data)!="undefined");
			},
			function(response){
				if(scroll_bottom_refresh){
					self._SCROLL_BOTTOM_LOADING=false;
				}
			});
        },
		updateMessageReadFlag: function(msg_ids) {
			//current foreach update,next update all after gmminf support
			var update_msg_url="/gmminf/accountapi/config";
			var notDoMarkRead=true;
			for(var i=0;i<msg_ids.length;i++){
				var params={
					src_code:11,
					method:"SetMessageStatus",
					params:JSON.stringify({
						msg_id: msg_ids[i]
					})
				};
				$.ajaxBridgeCache(update_msg_url,function(response){
					if($.BizReturnCodeCheck(response) && notDoMarkRead){
						notDoMarkRead=false;
						$.GmmMarkReadNewMsg();
					}
				},
				params,"GET",false,0,function (response){
					return false;
				});
			}
		},
        deleteMessages: function(msg_id){
            var self = this;
			var user_msg_url="/gmminf/accountapi/config";
			var params={
				src_code:11,
				method:"DeleteMessages",
				params:JSON.stringify({
					msg_ids: msg_id
				})
			};
			$.ajaxBridgeCache(user_msg_url,function(response){
				if($.BizReturnCodeCheck(response)){
					//删除Ajax缓存数据
					for(var i=1;i<=self.page;i++){
						var cached_page_params={
							src_code:11,
							method:"QueryMessage",
							params:JSON.stringify({
								is_read: 2,
								count:self.page_size,
								page:i
							})
						};
						$.clearAjaxCache(user_msg_url,cached_page_params,false);
					}
					self.getNews(1,false);
				}
			},
			params,"GET",false,0,function (response){
				return false;
			});
		},
		//取通用商品配置
		getCommonConfig:function() {
			var self = this;
			var url = "/gate/frontconfigapi";
			var params = {
				src_code: 11,
				method: "GetVersion",
				params: JSON.stringify({
					"object_id": "global_front_goods_type_cfg"
				})
			};
			$.ajaxBridgeCache(url, function (resp) {
				if ($.BizReturnCodeCheck(resp)) {
					var commonGoodsInfo = resp.data.memo;
					if (commonGoodsInfo.src_code_cfg && commonGoodsInfo.src_code_cfg['11']) {
						var config = commonGoodsInfo.src_code_cfg['11'];
						self.commonGoodsConfig(config);
					}
				}
			},
				params, "GET", false, 0, function (resp) {
				return false;
			});
		},
		isCommonGoods: function (goods_types) {
			if (this.commonGoodsConfig().goods_type_dic && this.commonGoodsConfig().goods_type_dic[goods_types]) {
				return true;
			} else {
				return false;
			}
		},
		/**
		 * @description: 开启jsim聊天
		 * @return {*}
		 */   
		getJsImOpenConfig:function(){
			var self = this;
			var url = "/gate/frontconfigapi/GetVersion";
			var params = {
				object_id:'jsim_open_config'
			};
			$.ajaxBridgeCache(url, function (resp) {
				if ($.BizReturnCodeCheck(resp)) {
					var result = resp.data.memo;
					if (result.open_config == 1){
						self.openJsIm(true);
					}
				}
			},
				params, "GET", false, 0, function (resp) {
				return false;
			});
		}
    };
	$.PageReadyEntry_Msg = function ()  {
		console.log('[PageReadyEntry-Msg]');

		if($.checkNotLogin($.PageReadyEntry_Msg)) return;
		_INDEX_MSG_VIEW_MODEL.getCommonConfig();
		_INDEX_MSG_VIEW_MODEL.getJsImOpenConfig();
		$.init();
		var koBindDom=$(".page-msg")[0];
		var koBindFlag=$(koBindDom).attr("gmm-bind-flag");
		if(koBindFlag!="1"){
			ko.applyBindings(_INDEX_MSG_VIEW_MODEL,koBindDom);
			$(koBindDom).attr("gmm-bind-flag","1");
			_INDEX_MSG_VIEW_MODEL.getNews(1,false);

			$('.page-msg').on("longTap",".msg-item",function(e) {
				var msg_id=$(e.currentTarget).attr("msg_id");
				if(msg_id!=""){
					$.confirm('确定删除这条消息？','删除消息',function(){
						_INDEX_MSG_VIEW_MODEL.deleteMessages(msg_id);
					});
				}
			});
			$('.page-msg').on('infinite', '.infinite-scroll-bottom',function() {
				if (_INDEX_MSG_VIEW_MODEL._SCROLL_BOTTOM_LOADING==false){
					_INDEX_MSG_VIEW_MODEL._SCROLL_BOTTOM_LOADING = true;
					console.log('[PageReadyEntry-Msg][Scroll-Bottom] Total Page=%s LastLoadPage=%s',_INDEX_MSG_VIEW_MODEL.total_page,_INDEX_MSG_VIEW_MODEL.page);
					if(_INDEX_MSG_VIEW_MODEL.total_page>_INDEX_MSG_VIEW_MODEL.page){
						_INDEX_MSG_VIEW_MODEL.getNews(_INDEX_MSG_VIEW_MODEL.page+1,true);
					}else{
						_INDEX_MSG_VIEW_MODEL._SCROLL_BOTTOM_LOADING=false;
					}
				}
			});
		}

	};
})(Zepto)
